import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#013957',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#35b9b6',
      contrastText: '#ffffff'
    },
    error: {
      main: '#d74242',
      contrastText: '#ffffff'
    }
  },
  typography: {
    fontFamily: ['Lato', 'Arial', 'sans-serif'].join(','),
    fontSize: 14
  },
  overrides: {
    MuiFormControl: {
      root: {
        width: '100%',
        maxWidth: 304,
        height: 'auto',
        padding: '0 0 10px 0',
        margin: '0 0 6px 0',
        borderWidth: 1,

       
        '& input:valid + fieldset': {
          borderColor: '#969696',
         

        },
       /*  '&$focused': {
          borderColor: '#013957',
         
        }, */
        /* '&$hover': {
          borderColor: '#484848'
        }, */
      },
      
    },

    //Radio
/*     .Mui-checked
    // MultipleSelect
    MuiInput: {
      formControl: {
        marginTop: '0 !important'
      }
    }, */
    MuiInputBase: {
      //Caja del Input
      root: {
        // height: 40,
        minHeight: 48,
        fontSize: 16,
        margin: 0,
        color: '#969696',
        backgroundColor: 'white',
        /* '&$error': {
          color: '#d74242'
        },
        '&$hover': {
          borderColor: '#484848'
        },
        '&$focused': {
          color: '#013957',
         
        },         */
      },

      input:{
        color: '#969696',
        '&$error': {
          color: '#d74242'
        },
        /* '&$hover': {
          borderColor: '#484848'
        },
        '&$focused': {
          color: '#013957',
         
        },         */
      },
      
     
      formControl: { marginTop: 0 }
    },
    MuiFormHelperText: {
      root: {
        fontSize: 12
      },
      contained: { 
        margin :'2px 14px 0'}
    },
    MuiAutocomplete:{
      inputRoot:{
        '&[class*="MuiOutlinedInput-root"]:not(.MuiOutlinedInput-marginDense)': {
          padding: '0 62px 0 9px',
        }
      },
    },
    

    MuiOutlinedInput: {
      root: {
        borderRadius: 2,
        '&:hover': {
          background: 'white'
        }
      },
      input: {
        padding: '10px 14px'
      },
      //Error
      notchedOutline: {
        borderColor: '#969696'
      }
    },
    PrivateNotchedOutline: {
      root: {
        borderRadius: 2,
        borderColor: '#484848'
      }
    },
    MuiInputLabel: {
     
      outlined: {
        transform: 'translate(14px, 16px) scale(1)'
      }
    },
    MuiFormLabel: {
      root:{
        color: '#969696',
        zIndex: '99',
      },
      filled:{
        color: '#484848'
      }
    },
    MuiBackdrop: {
      root: {
        backgroundColor: 'rgba(16,108,157,0.55)'
      }
    },

    MuiTextField:{
      root:{
        height: 74
      } 
    },

    MuiSelect:{
      root:{
        height: 74
      } ,
    },

    MuiAppBar:{
      root:{
        zIndex: 9999
      }
    }

    // Radio
   

    // MuiFormLabel: {
    //   // Name of the component ⚛️ / style sheet
    //   error: {
    //     color: 'blue'
    //   },
    //   root: {
    //     // Name of the rule
    //     color: 'orange',
    //     '&$focused': {
    //       // increase the specificity for the pseudo class
    //       color: '#484848'
    //     }
    //   }
    // }
  }
});

export default theme;
